import RankSixteen from '@assets/icons/rank-sixteen.svg'
import { Icon } from './Icon'

export const RankSixteenIcon = Icon(RankSixteen)
